import { DataProvider } from 'assets/providers/data/DataProvider';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import useClaimJobPaymentItem from './Finance.ClaimJobPaymentItem.Hooks';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ClaimJobPaymentItemList from './sections/Finance.ClaimJobPaymentItem.List';
import CreateClaimJobPaymentFromItems from './sections/Finance.ClaimJobPaymentItem.AddPayment';

export const financeClaimJobPaymentItemIndexRoute = financeHomeRoute + '/claimJobPaymentItem/:action?/:id?';
export default function FinanceClaimJobPaymentItemIndex() {
  const claimJobPaymentItemHook = useClaimJobPaymentItem();

  if (!claimJobPaymentItemHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={claimJobPaymentItemHook}
        render={({ views }) => (
          <>
            {views.createPayment && <CreateClaimJobPaymentFromItems />}
            <ClaimJobPaymentItemList />
          </>
        )}
      />
    </>
  );
}
